import { useMemo } from 'react'
import { CashFund } from '../../../../administration'
import { RoutePath } from '../../../../../features/routes'
import { WidgetCard } from '../widget-card/widgetCard'
import { WidgetList, WidgetListRow } from '../widget-list/widgetList'
import { formatAmount } from '../../../utils/dashboardUtils'

type Props = {
    loading: boolean
    error: boolean
    cashFunds: CashFund[]
}

export const CashFundsWidget = (props: Props) => {
    const { loading, error, cashFunds } = props

    const rows = useMemo((): WidgetListRow[] => [...cashFunds]
        .sort((a, b) => b.availableAmount - a.availableAmount)
        .map(cashFund => ({
            key: cashFund.id,
            label: cashFund.name,
            value: formatAmount(cashFund.availableAmount),
            valueKind: cashFund.availableAmount < 0 ? 'negative' : 'default'
        }))
    , [cashFunds])

    return (
        <WidgetCard
            title="Cajas activas"
            loading={loading}
            error={error}
            empty={!loading && !error && rows.length === 0}
            linkLabel="Ver cajas"
            linkPath={RoutePath.CASH_FUNDS}
        >
            <WidgetList rows={rows} maxRows={6} />
        </WidgetCard>
    )
}
